class PopulateFields {
  constructor() {
    this.button = document.getElementById("populate-button");
    if (this.button) {
      this.bindEvents();
    }
  }

  bindEvents() {
    // DOM-related initializations here
    this.sourceField = document.getElementById(`input_5_2`);
    this.targetField = document.getElementById(`input_5_18`);

    if (this.sourceField && this.targetField) {
      this.button.addEventListener("click", this.populateField.bind(this));
    } else {
      console.error("Source field, target field, or button is null");
    }
  }

  populateField() {
    this.targetField.value = this.sourceField.value;
  }
}

export default PopulateFields;
